import { ICase } from 'src/types/case';
import { CaseFormData } from 'src/screens/General/screens/Cases/components/CaseForm';
export const toFormValues = (caseEnt: Partial<ICase>, types: any): Partial<CaseFormData> => {
    const {
        student,
        serviceType,
        orderType,
        invoiceSigner,
        status,
        minPerUnit,
        serviceLocation,
        provider,
        caseType,
        orderEntity,
        district,
        vendor,
        serviceTypeProvider,
        //   authorizationSource,
        // allocatedPeriod,
        //    orderSubtype,
        //   allocatedHours,
        //    allocatedMoney,
        ...data
    }: Partial<ICase> = caseEnt;
    const dataForm: any = { ...data };

    dataForm.caseStatusDropdown = status
        ? types.statusValues.find((it: SelectObject) => it.value === status)
        : undefined;
    dataForm.orderTypeDropDown = orderType
        ? types.OrderTypes.find((it: SelectObject) => it.value === orderType)
        : undefined;
    dataForm.invoiceSignerDropdown = invoiceSigner
        ? types.invoiceSignerValues.find((it: SelectObject) => it.value === invoiceSigner)
        : undefined;
    dataForm.serviceTypeProviderDropDown = serviceTypeProvider
        ? types.serviceTypeProviderValues.find((it: SelectObject) => it.value === serviceTypeProvider)
        : undefined;
    dataForm.minPerUnitDropdown = minPerUnit
        ? types.minPerUnitValues.find((it: SelectObject) => it.value === minPerUnit)
        : undefined;
    dataForm.serviceLocationDropDown = serviceLocation
        ? { label: serviceLocation.title, value: serviceLocation.id }
        : undefined;

    dataForm.providerDropDown = provider ? { label: provider.fullName, value: provider.id } : undefined;

    dataForm.minPerUnitDropdown = minPerUnit
        ? types.minPerUnitValues.find((it: SelectObject) => it.value === minPerUnit)
        : undefined;

    dataForm.caseTypeDropDown = caseType
        ? types.caseTypes.find((it: SelectObject) => it.value === caseType)
        : undefined;

    dataForm.ordersDropDown = orderEntity ? { label: orderEntity.name, value: orderEntity.id } : undefined;
    if (caseType && 1 !== +caseType) {
        dataForm.serviceTypeDropDown = serviceType
            ? { label: serviceType.title ? serviceType.title : '', value: serviceType.id, cpt: serviceType.cpt }
            : undefined;
        dataForm.studentDropDown = student
            ? { label: `${student.firstName} ${student.lastName}`, value: student.id }
            : undefined;
    }
    if (caseType && 3 === +caseType && student) {
        dataForm.studentDropDown = student
            ? { label: `${student.firstName} ${student.lastName}`, value: student.id }
            : undefined;
    }
    if (district) {
        dataForm.districtDropDown = district ? { label: district.name, value: district.id } : undefined;
    }
    if (vendor) {
        dataForm.vendorDropDown = vendor ? { label: vendor.name, value: vendor.id } : undefined;
    }

    return dataForm;
};
